export default __webpack_public_path__ + "static/media/Knife_HTB.72a449b4.md";